module.exports = __webpack_public_path__ + "static/pic02-9a15be211ed2df3f7191358f1db63472.jpg";